module.exports = __webpack_public_path__ + "static/media/comment-alt-notes.a03ce32d.svg";